import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { AppIcon } from '../components/AppIcon';
export function SplashScreen() {
  const navigate = useNavigate();
  useEffect(() => {
    const timer = setTimeout(() => {
      navigate('/intro');
    }, 2500);
    return () => clearTimeout(timer);
  }, [navigate]);
  return <div className="min-h-screen w-full bg-white flex flex-col items-center justify-center animate-fadeInUp" data-id="element-2208" data-mp="1hjuvk0l596pl">
      <AppIcon size={420} className="w-[320px] h-[320px] sm:w-[400px] sm:h-[400px] md:w-[500px] md:h-[500px]" data-id="element-2209" data-mp="1mh3dc02dr8qb" />
      <p className="font-sans text-[18px] font-medium text-primary italic -mt-2 sm:-mt-4 text-center px-6" data-id="element-2210" data-mp="1vib29rj0ax7q">
        Every breath counts
      </p>
    </div>;
}